import React from 'react'
import { NotificationType } from './notification'
import useAppNotificationStore from '../../../../stores/notification/appNotificationStore'
import { NotificationInfoResult } from '../../../../services/web/types/responseWebServiceTypes'
import { encryptionAES } from '../../../../utilities/encryption'
import { RoutePath } from '../../../../router/routesConfig'
import { generatePath, useHistory } from 'react-router-dom'
import useWebService from '../../../../services/web/useWebService'
import useAuthenStore from '../../../../stores/authen/authenStore'
import useAppNotificationAction from '../../../../stores/notification/appNotificationAction'

export default (props: NotificationType) => {
    const [notiInfoList, setNotiInfo] = React.useState<NotificationInfoResult[]>()
    const [openNotiList, setOpen] = React.useState(false)
    const appNotificationStore = useAppNotificationStore()
    const callWebService = useWebService()
    const profileStore = useAuthenStore()
    const appNotificationAction = useAppNotificationAction()

    const anchorRef = React.useRef(null)
    const history = useHistory()

    React.useEffect(() => {
        setNotification()
    }, [appNotificationStore.notificationInfo])

    const setNotification = () => {
        if (appNotificationStore.notificationInfo) {
            setNotiInfo(appNotificationStore.notificationInfo)
        }
    }
    const handleClickList = (notiInfo: NotificationInfoResult) => (event: any) => {
        handleClose(event)
        // deleteAndGetNoti(notiInfo.notifyID)
        updateWatchedNoti(notiInfo.notifyID)
        const encryptedProjectID = encryptionAES(`${notiInfo.projectID}`)
        const encryptedSubmittedID = encryptionAES(`${notiInfo.submittedID}`)

        const path = generatePath(RoutePath.manageProjectEdit, {
            projectID: encryptedProjectID,
            submittedID: encryptedSubmittedID,
        })

        history.push({
            pathname: path,
            state: {
                // location state
                // irb: row.irb,
                // mode: renderMode.view,
            },
        })
        window.location.reload()
    }
    const updateWatchedNoti = async (notifyID: number) => {
        await callWebService.updateWatchedNotification({ notiID: notifyID })
        getNotificationInfo()
    }
    const deleteAndGetNoti = async (notifyID: number) => {
        await callWebService.deleteNotificationInfo(notifyID)
        getNotificationInfo()
    }
    const getNotificationInfo = async () => {
        if (profileStore.profile.userId) {
            const res = await callWebService.getNotificationInfo(profileStore.profile.userId) //profileStore

            appNotificationAction.setNotificationInfo(res.result)
        }
    }

    const handleClose = (event: any) => {
        if (anchorRef && anchorRef.current) {
            //@ts-ignore
            if (anchorRef.current.contains(event.target)) {
                return
            }
        }

        setOpen(false)
    }
    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen)
    }
    const handleClickDeleteNoti = (notiInfo: NotificationInfoResult) => (event: any) => {
        event.stopPropagation()

        deleteAndGetNoti(notiInfo.notifyID)
    }
    return {
        notiInfoList,
        openNotiList,
        anchorRef,
        onClickList: handleClickList,
        onclickClose: handleClose,
        onclickToggle: handleToggle,
        onclickDeleteNoti: handleClickDeleteNoti,
    }
}
